import { render, staticRenderFns } from "./ListKosakuAddress.vue?vue&type=template&id=36be4550&scoped=true&"
import script from "./ListKosakuAddress.vue?vue&type=script&lang=js&"
export * from "./ListKosakuAddress.vue?vue&type=script&lang=js&"
import style0 from "@/styles/table-styles.css?vue&type=style&index=0&id=36be4550&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36be4550",
  null
  
)

export default component.exports